<template>
<div :class="[{ grants: !toggleDown }]" style=" z-index: 10; position: relative;">
  <section @click="getProductionGrants">
    <span  v-if="icon">
      <img src="../../assets/research/icon_grants.png" class="pl-1">
      <img  v-if="toggleDown"  src="../../assets/research/down.png" class="pt-1 pl-0">
      <img v-else src="../../assets/research/up.png" class="pt-1 pl-0">
    </span>
    <span v-else class="grant text-body-2 text-md-caption">Grants
      <span  v-if="toggleDown" class="pt-1 px-1 text-body-1">+</span>
      <span v-else class="pt-1 px-1 font-weight-bold text-body-1">-</span>
    </span>
  </section>
  <ul v-if="!toggleDown" class="pl-1 text-body-2 text-md-caption" >
    <li v-for="(item,index) in grants" :key="index" >
        <a v-if="item.url" :href="item.url">
            <span class="text-body-2 text-md-caption">{{item.name}}</span>
        </a>
        <router-link v-else
            :to="{name:'grant',params:{id:item.id_grant}}"  tag="a">
            <span class="text-body-2 text-md-caption">{{item.name}}</span>
        </router-link>
    </li>
  </ul>
</div>
</template>
<script>
export default {
  props:['grants','icon'],
  data(){
    return{
      toggleDown:true,
    }
  },
  methods:{
    getProductionGrants() {
      this.toggleDown = !this.toggleDown;
      return this.grants;
    }
  }
}
</script>
<style scoped>
.grants{
  background-color:bisque
}
/* .nogrants{
  background-color: white
} */
.grant {
  border: 1px solid  #303f9f;
  padding: 2px;
  border-radius: 4px;
}
</style>

